import de from './translations/de.json';
import en from './translations/en.json';
import fr from './translations/fr.json';

export const resources = {
  de: { translation: de },
  en: { translation: en },
  fr: { translation: fr },
} as const;
